module.exports = __webpack_public_path__ + "img/ccfListLogo.2b88a76c.png";